import React from "react";
import TopBar from "../TopBar/TopBar";
import ReactMarkdown from 'react-markdown';

import "./PrivacyPolicy.scss";

const PrivacyPolicy: React.FC = () => {
  const markdownContent = `## PRIVACY POLICY

This Privacy Policy describes how **Pacer.co** (operating as **KickTheTires.ai**) collects, uses, and discloses your personal information when you use our AI-powered vehicle diagnostic services.

---

### **1. Information We Collect**

We collect information that identifies, relates to, or could reasonably be linked to you ("Personal Information").

* **Owner Information:** When you use our lead generation or "Trade-in" features, we collect your name, email address, and telephone number.  
* **Vehicle Information:** We collect vehicle identifiers (VINs), listing URLs, and any photos of vehicles you upload for analysis.  
* **Usage Data:** We automatically collect your IP address, browser type, and information about how you interact with our "Scout" reports.

### **2. How We Use Your Information**

We use your information to provide and improve our AI diagnostic tools.

* **Report Generation:** To "read between the lines" of vehicle listings and provide forensic photo analysis.  
* **Lead Generation:** To facilitate connections between you and automotive dealerships when you request a trade-in value or dealer contact.  
* **AI Improvement:** We use anonymized, aggregated data derived from vehicle analyses to refine our diagnostic models.

### **3. Data Sharing & "Push" to Dealerships**

By opting into our dealership connection features, you grant us express permission to "push" your information to third-party automotive dealers.

* **Information Shared:** We share your **Owner Information** (Name, Contact) alongside the **Vehicle Information** and our AI-generated condition reports.  
* **Dealer Responsibility:** Once transferred, the dealership acts as an **independent data controller**. They are required by federal law (FTC Safeguards Rule) to maintain their own information security programs to protect your data.  
* **No Sale of Data:** Aside from these requested dealership "pushes," Pacer.co does **not** sell your personal information to third-party marketing firms.

### **4. Data Retention & Ownership**

* **Secure Deletion:** To protect your privacy, Pacer.co securely processes raw documents and photos and deletes these specific files after your report has been generated.  
* **Analytical Ownership:** Pacer.co retains all ownership rights to the analytical output, including "Scout" reports and proprietary condition scores.  
* **Retention Period:** We retain basic account and transaction history for as long as necessary to fulfill the purposes outlined in this policy or as required by law.

### **5. Your Choices & Rights**

* **Opt-Out:** You may choose not to share your data with dealerships, though this will limit your ability to use certain trade-in and valuation features.  
* **Access & Deletion:** You may request a copy of your personal data or ask that we delete your account information at any time.

### **6. Governing Law & Disputes**

This Privacy Policy is governed by the laws of the **State of Delaware**. Any disputes regarding your privacy will be handled through **binding individual arbitration**, as outlined in our Terms of Service.`;

  return (
    <div className="privacy-policy-page">
      <TopBar title="Privacy Policy" />
      <div className="privacy-policy-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
        {/* Add your privacy policy content here */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
